<template>
    <div class="terms">
        <div class="top-bar">
        <h1>Talki - Políticas</h1>
    </div>
    <div class="container">
        <p><strong>I. POLÍTICA DE PRIVACIDAD</strong></p>
        <p>Esta Política de Privacidad establece los términos bajo los cuales Talki utiliza y protege la información
            proporcionada por los usuarios al utilizar su aplicación. La seguridad de los datos de los usuarios es una
            prioridad para nosotros. Cuando solicitamos que complete campos con información personal para identificarlo,
            garantizamos que esta información se utilizará de acuerdo con los términos de este documento. Sin embargo,
            tenga en cuenta que esta Política de Privacidad puede cambiar con el tiempo, por lo que le recomendamos que
            la revise periódicamente para asegurarse de que esté de acuerdo con las actualizaciones.</p>

        <p><strong>II. INFORMACIÓN RECOPILADA</strong></p>
        <p>Nuestra aplicación puede recopilar información personal, como su nombre, información de contacto (como su
            dirección de correo electrónico) y datos demográficos.</p>

        <p><strong>III. USO DE LA INFORMACIÓN RECOPILADA</strong></p>
        <p>Utilizamos la información para brindar el mejor servicio posible, como el registro de usuarios.
            Ocasionalmente, podemos enviar correos electrónicos con ofertas especiales, nuevos productos y otra
            información publicitaria que consideremos relevante. Talki se compromete a mantener su información segura
            utilizando sistemas avanzados y actualizaciones constantes para prevenir accesos no autorizados.</p>

        <p><strong>IV. ENLACES A TERCEROS</strong></p>
        <p>Esta aplicación puede contener enlaces a otros sitios web que podrían ser de su interés. Una vez que abandona
            nuestra aplicación haciendo clic en estos enlaces, perdemos el control sobre la información que comparte en
            esos sitios de terceros, que tienen sus propias políticas de privacidad.</p>

        <p><strong>V. MANEJO DE DATOS DE MENORES DE EDAD</strong></p>
        <p>Talki reconoce la importancia de proteger la privacidad de los menores de edad. No recopilamos
            intencionalmente información personal de usuarios menores de edad.</p>

        <p><strong>VI. PUBLICIDAD</strong></p>
        <p>Talki puede mostrar anuncios dentro de la aplicación con el fin de mantener el servicio gratuito para los
            usuarios. Estos anuncios pueden ser proporcionados por terceros y pueden recopilar información no personal
            para personalizar el contenido publicitario.</p>

        <p>Los usuarios comprenden y aceptan que los clics en anuncios pueden redirigirlos a sitios web o aplicaciones
            de terceros con políticas de privacidad independientes. Talki no tiene control sobre el contenido o las prácticas de
            privacidad de estos.</p>

        <p><strong>VII. CAMBIOS EN LA POLÍTICA DE PRIVACIDAD</strong></p>
        <p>Talki se reserva el derecho de cambiar los términos de esta Política de Privacidad en cualquier momento.
            Cualquier modificación se reflejará en esta página, y el uso continuado de la aplicación constituirá su
            aceptación de dichos cambios.</p>
    </div>
    </div>
  </template>
        
  <script>
  export default {
    name: "TermsView",
    data() {
      return {
        section: null,
        sectionData: {
          name: "",
          visible: false,
        },
      };
    },

  };
  </script>
      
  <style scoped>
    html {
        margin: 0;
    }

    body {
        font-family: 'Manrope', sans-serif;
        margin: 0;
    }

    .top-bar {
        background-color: var(--main-color);
        padding: 20px;
        margin-bottom: 10px;
    }

    .top-bar h1 {
        margin: 0;
        color: white;
        letter-spacing: 1.5px;
        font-weight: bold;
    }

    .container {
        width: 70%;
        margin: 30px auto;
    }


    h1 {
        text-align: center;
    }

    h2 {
        font-size: 28px;
    }

    h3 {
        font-size: 24px;
        margin-bottom: 8px;
    }

    p {
        font-size: 20px;
        text-align: justify;
        margin: 0;
        margin-bottom: 20px;
    }

    p strong {
        font-size: 24px;
    }
  </style>